import { Dialog } from "primereact/dialog";
import { useState, useEffect } from "react";
import dbManagerInterface from "../../Utility/DbConnection/DBManagerInterface";

function PieceImageDialog({ visible, onHide, pieceId, client, machine }) {
  const [mediaUrl, setMediaUrl] = useState(null);
  const [isVideo, setIsVideo] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !pieceId) return;

    setLoading(true);
    dbManagerInterface.FetchPieceImageUrl(
      client,
      machine,
      pieceId,
      (resp) => {
        if (resp && resp.data) {
          const url = resp.data;
          console.log("Piece media URL:", url);
          setMediaUrl(url);

          // Simple file type detection
          const videoExtensions = [".mp4", ".webm", ".ogg", ".mov"];
          const lowerUrl = url.toLowerCase();
          const isVid = videoExtensions.some((ext) => lowerUrl.includes(ext));
          setIsVideo(isVid);
        } else {
          setMediaUrl(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching piece media URL:", error);
        setMediaUrl(null);
        setLoading(false);
      }
    );
  }, [visible, pieceId, client, machine]);

  return (
    <Dialog
      header="Piece Media"
      visible={visible}
      style={{ width: "60vw", maxWidth: "800px" }}
      modal
      onHide={onHide}
    >
      {loading ? (
        <p>Loading...</p>
      ) : mediaUrl ? (
        isVideo ? (
          <video
            src={mediaUrl}
            controls
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              display: "block",
              margin: "10 auto",
              borderRadius: "8px",
            }}
          />
        ) : (
          <img
            src={mediaUrl}
            alt={`Piece ${pieceId}`}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              display: "block",
              margin: "10 auto",
              borderRadius: "8px",
            }}
          />
        )
      ) : (
        <p>No media available</p>
      )}
    </Dialog>
  );
}

export default PieceImageDialog;
